// Todo: implement env variables
export const API_URL =
  (process.env.REACT_APP_API_URL as string) ||
  "https://eakcize.mfin.gov.rs/api/";
export const eIdUrl = "https://eakcize.mfin.gov.rs/api/LoginSSO";
export const eIdProUrl = "https://eakcize.mfin.gov.rs/api/LoginSSOPro";
